import React from 'react';
import { SubscriptionsPlansWrapper, SubscriptionsTable } from '../SubscriptionsPlans.style';
import { IonSegment, IonSegmentButton, IonSkeletonText } from '@ionic/react';
import { SubscriptionRowStyled } from '../SubscriptionRow/SubscriptionRow.style';
import SubscriptionAdvantages from '../../../components/SubscriptionAdvantages';

const SubscriptionsPlansSkeleton = () => {
  return (
    <SubscriptionsPlansWrapper>
      <span className={'plans-step'}>
        <IonSkeletonText
          animated
          style={{
            margin: 0,
            padding: 0,
            width: '70px',
            height: '14px',
            borderRadius: '6px',
          }}
        />
      </span>
      <h3 className={'plans-title'}>
        <IonSkeletonText
          animated
          style={{
            margin: 0,
            padding: 0,
            width: '225px',
            height: '24px',
            borderRadius: '6px',
          }}
        />
      </h3>
      <SubscriptionAdvantages isLoading={true} style={{ marginBottom: '26px' }} />
      <IonSegment mode={'ios'} className={'plans-segment'}>
        {new Array(3).fill('').map((i, index) => (
          <IonSegmentButton key={index} className={'plans-segment-button loading'}>
            <IonSkeletonText
              animated
              style={{
                margin: 0,
                padding: 0,
                width: '100%',
                height: '60px',
                borderRadius: '6px',
              }}
            />
          </IonSegmentButton>
        ))}
      </IonSegment>
      <SubscriptionsTable>
        {new Array(3).fill('').map((i, index) => (
          <React.Fragment key={index}>
            <SubscriptionRowStyled className={`month with-border`}>
              <IonSkeletonText
                animated
                style={{
                  display: 'inline-block',
                  margin: 0,
                  padding: 0,
                  width: index === 0 ? '80px' : '91px',
                  height: '20px',
                  borderRadius: '6px',
                }}
              />
            </SubscriptionRowStyled>
            <SubscriptionRowStyled className={`discount with-border ${index === 1 ? 'active' : ''}`}>
              <div className={'row-desc'}>
                <IonSkeletonText
                  animated
                  style={{
                    display: 'inline-block',
                    margin: 0,
                    padding: 0,
                    width: '53px',
                    height: '12px',
                    borderRadius: '6px',
                  }}
                />
              </div>
              <IonSkeletonText
                animated
                style={{
                  display: 'inline-block',
                  margin: 0,
                  padding: 0,
                  width: index === 0 ? '27px' : index === 1 ? '41px' : '47px',
                  height: '20px',
                  borderRadius: '6px',
                }}
              />
            </SubscriptionRowStyled>
            <SubscriptionRowStyled className={`price`}>
              <IonSkeletonText
                animated
                style={{
                  display: 'inline-block',
                  margin: 0,
                  padding: 0,
                  width: index === 0 ? '63px' : '71px',
                  height: '33px',
                  borderRadius: '6px',
                }}
              />
            </SubscriptionRowStyled>
          </React.Fragment>
        ))}
      </SubscriptionsTable>
      <button className={'plans-footer-help'}>
        <IonSkeletonText
          animated
          style={{
            display: 'inline-block',
            margin: 0,
            padding: 0,
            width: '208px',
            height: '24px',
            borderRadius: '6px',
          }}
        />
      </button>
    </SubscriptionsPlansWrapper>
  );
};

export default SubscriptionsPlansSkeleton;
